define([
    "./tripOperationHistoryModule",
    "text!./tripOperationHistoryModal.html"
], function (tripOperationHistoryModule, tripOperationHistoryModalTemplate) {
    "use strict";

    /**
     * @ngdoc service
     * @name tripOperationHistoryModal
     * @description
     * Exibe o histórico de operações de uma trip, através do nodeCommand
     *
     * @param {nodeIdentifier[]} selection unitária contendo uma trip
     * @returns {promise} Promessa que é resolvida quando o modal é fechado.
     * */

    return tripOperationHistoryModule.service("tripOperationHistoryModal", ["$q", "$modal", "tripOperationHistoryService",
        function ($q, $modal, tripOperationHistoryService) {
            return {
                openModal: function (selection) {
                    openModal(selection);
                }
            };

            function openModal(selection) {
                var tripNodeIdentifier = selection[0];
                $modal.open({
                    template: tripOperationHistoryModalTemplate,
                    size: "lg",
                    backdrop: "static",
                    controller: ["$scope", function ($scope) {
                        $scope.shouldContinueLoadOperations = false;
                        $scope.isLoading = true;
                        $scope.isContinueLoading = true;
                        $scope.tripOperationHistories = {};
                        $scope.lastTripRevision = 0;
                        $scope.tableOptions = {
                            records: [],
                            columns: [{
                                header: "trip.operation.history.modal.history.tr.edition.date",
                                cell: "{{ :: tripOperationHistory.editionDate | date:'dd/MM/yyyy HH:mm:ss' }}",
                                sortBy:"editionDate"
                            }, {
                                header: "trip.operation.history.modal.history.tr.user",
                                cell: "{{ :: ((tripOperationHistory.user | entityFormat) || 'N/A') }}",
                                name: "user",
                                sortBy:"user"
                            }, {
                                header: "trip.operation.history.modal.history.tr.routingConfig",
                                cell: "{{ :: tripOperationHistory.routingConfig | entityFormat }}",
                                name: "routingConfig",
                                sortBy: "routingConfig"
                            }, {
                                header: "trip.operation.history.modal.history.tr.permissionGroup",
                                cell: "{{ :: tripOperationHistory.permissionGroup | entityFormat }}",
                                name: "permissionGroup",
                                sortBy:"permissionGroup"
                            }, {
                                header: "trip.operation.history.modal.history.tr.quantityOfViolations",
                                cell: "{{ :: tripOperationHistory.violationOperations[0].violations.length || 0 }}",
                                name: "violationsQuantity",
                                sortBy:"violationOperations[0].violations.length || 0"
                            }]
                        };


                        $scope.hasTripOperationHistories = function () {
                            return $scope.tripOperationHistories.length > 0;
                        };

                        $scope.isShouldContinueLoadOperations = function (records) {
                            return records.length !== 0;
                        };

                        $scope.existsViolationOperations = function (tripOperationHistory) {
                            return tripOperationHistory.violationOperations.length;
                        };

                        $scope.init = function () {
                            tripOperationHistoryService.findTripOperationHistoryUrlForNodeIdentifier(tripNodeIdentifier, $scope.lastTripRevision)
                                .then(function (tripOperationHistories) {
                                    $scope.isLoading = false;
                                    if (tripOperationHistories.length === 0) {
                                        return;
                                    }
                                    $scope.tripOperationHistories = tripOperationHistories;
                                    $scope.tripInfo = {
                                        tripCode: $scope.tripOperationHistories[0].tripCode
                                    };
                                    $scope.loadOperations();
                                });
                            if ($scope.tripOperationHistories.length > 0) {
                                $scope.loadOperations();
                            }
                        };

                        $scope.loadOperations = function () {
                            $scope.lastTripRevision = $scope.tripOperationHistories[$scope.tripOperationHistories.length - 1].finalRevision;
                            tripOperationHistoryService.findTripOperationHistoryUrlForNodeIdentifier(tripNodeIdentifier, $scope.lastTripRevision)
                                .then(function (otherTripOperationHistories) {
                                    $scope.isContinueLoading = false;
                                    $scope.shouldContinueLoadOperations = $scope.isShouldContinueLoadOperations(otherTripOperationHistories);
                                    $scope.tripOperationHistories = $scope.tripOperationHistories.concat(otherTripOperationHistories);
                                    $scope.lastTripRevision = $scope.tripOperationHistories[$scope.tripOperationHistories.length - 1].finalRevision;
                                });
                            if ($scope.shouldContinueLoadOperations) {
                                $scope.loadOperations();
                            }
                        };
                        $scope.init();
                    }]
                });
            }

        }
    ]);
});